import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaUserGraduate,
  FaFilePdf,
} from "react-icons/fa";
import "./PlanaDocente.css";



// fotos de Docentes
import fotoVidalon from "../assets/nosotros/plana_docente/HECTOR_JORGE_VIDALON_JORGE.jpg";
import fotoPachas from "../assets/nosotros/plana_docente/PEDRO_PACHAS_BARRIONUEVO.jpg";
import fotoBenites from "../assets/nosotros/plana_docente/PATRICIA_JANET_BENITES_YGLESIAS.png";
import fotoTasayco from "../assets/nosotros/plana_docente/CARLOS_TASAYCO_YATACO.jpg";
import fotoVega from "../assets/nosotros/plana_docente/HUMBERTO_PABLO_VEGA_CRUZ.png";
import fotoGarriazo from "../assets/nosotros/plana_docente/JOHN_HARRY_GARRIAZO_CASTAÑEDA.jpg";
import fotoFlores from "../assets/nosotros/plana_docente/CHRISTIAN_FEDERICO_FLORES_VARGAS.jpg";
import fotoCortez from "../assets/nosotros/plana_docente/JOSÉ_RICARDO_CORTEZ_CAMACHO.jpg";
import fotoChuan from "../assets/nosotros/plana_docente/ANTHONY_FRANCISCO_CHUAN_GARCIA.png";
import fotoChacaltana from "../assets/nosotros/plana_docente/LUIS_ALBERTO_CHACALTANA_ARNAO.png";

import fotoElsa from "../assets/nosotros/plana_docente/ELSA_CASTILLA_ALMEYDA.jpg";
import fotoTeresaCajo from "../assets/nosotros/plana_docente/TERESA_CAJO_ROJAS.jpg";
import fotoMariaCristina from "../assets/nosotros/plana_docente/MARIA_CRISTINA_MAGUINA_MALLMA.jpg";
import fotoMarisela from "../assets/nosotros/plana_docente/MARISELA_JANET_PALACIOS_CASTILLO.jpg";
import fotoNorma from "../assets/nosotros/plana_docente/NORMA_YOLANDA_QUISPE_MOLINA.jpg";
import fotoValderrama from "../assets/nosotros/plana_docente/FERNANDO_VALDERRAMA_CASTRO.jpg";
import fotoLuisa from "../assets/nosotros/plana_docente/LUISA_VERONICA_SANCHEZ_GARCIA.jpg";
import fotoElizabeth from "../assets/nosotros/plana_docente/ELIZABETH_MANUELA_ORE_CALLIRGOS.jpg";
import fotoCoralia from "../assets/nosotros/plana_docente/CORALIA_VILCA_GONZALES.jpg";

import fotoFabiola from "../assets/nosotros/plana_docente/FABIOLA_RODRIGUEZ_VEGA.jpg";
import fotoDiana from "../assets/nosotros/plana_docente/DIANA_NOELIA_SAENZ_CHARAJA.jpg";
import fotoTeresaMontoya from "../assets/nosotros/plana_docente/TERESA_LILIANA_MONTOYA_VILLASANTE.jpg";
import fotoVicente from "../assets/nosotros/plana_docente/VICENTE_EGUSQUIZA_POZO.jpg";
import fotoLeonor from "../assets/nosotros/plana_docente/LEONOR_NIETO_POCOMUCHA.jpg";
import fotoLizbeth from "../assets/nosotros/plana_docente/LIZBETH_FABIOLA_JARA_RARAZ.jpg";
import fotoSandra from "../assets/nosotros/plana_docente/SANDRA_ORE_CALDERON.jpg";
import fotoMercedes from "../assets/nosotros/plana_docente/MERCEDES_FUENTES_LAZO.jpg";

import fotoCurampa from "../assets/nosotros/plana_docente/CESAR_AUGUSTO_CURAMPA_DE_LA_CRUZ.jpg";
import fotoMoises from "../assets/nosotros/plana_docente/VARGAS_SOTO_MOISES.jpg";
import fotoMamani from "../assets/nosotros/plana_docente/LUIS_AGUSTIN_MAMANI_CHIPANA.jpg";
import fotoGuillermo from "../assets/nosotros/plana_docente/GUILLERMO_CARLOS_BARBOZA_TELLO.jpg";
import fotoJimmy from "../assets/nosotros/plana_docente/JIMMY_QUISPE_LLAMOCA.jpg";
import fotoFelix from "../assets/nosotros/plana_docente/FELIX_HANS_RIVAS_CALLA.jpg";
import fotoMontano from "../assets/nosotros/plana_docente/JUAN_JOSE_MONTANO_VEGA.jpg";
import fotoWashington from "../assets/nosotros/plana_docente/WASHINGTON_RAMIREZ_PATINO.jpg";
import fotoPanebra from "../assets/nosotros/plana_docente/JUAN_CARLOS_PANEBRA_MONTES.jpg";

import fotoYolanda from "../assets/nosotros/plana_docente/YOLANDA_SUAREZ_DIAZ.jpg";
import fotoCarmen from "../assets/nosotros/plana_docente/CARMEN_ROSA_ACCO_GAVILAN.jpg";
import fotoCanelo from "../assets/nosotros/plana_docente/SEBERINO_ALBERTO_CANELO_BLAS.jpg";
import fotoMiguel from "../assets/nosotros/plana_docente/MIGUEL_RAMIRO_HUARCAYA_FERNANDEZ.jpg";
import fotoFiorela from "../assets/nosotros/plana_docente/FIORELA_JEANETTE_ORTIZ_ORTIZ.jpg";
import fotoJohao from "../assets/nosotros/plana_docente/JOHAO_JUNIOR_RODRIGUEZ_QUISHAC.jpg";
import fotoEmilia from "../assets/nosotros/plana_docente/EMILIA_RAMIREZ_ARNAO.jpg";
import fotoShannon from "../assets/nosotros/plana_docente/SHANNON_CALDERON_QUISPE.jpg";

import fotoNilton from "../assets/nosotros/plana_docente/NILTON_AQUILES_MICHUY_SUYO.jpg";
import fotoRichard from "../assets/nosotros/plana_docente/RICHARD_MARIO_CELIS_CALERO.jpg";
import fotoDaniel from "../assets/nosotros/plana_docente/DANIEL_QUISPE_DE_LA_TORRE.jpg";
import fotoRanilla from "../assets/nosotros/plana_docente/JUAN_LEOPOLDO_RANILLA_MEDINA.jpg";
import fotoWilmer from "../assets/nosotros/plana_docente/WILMER_ALARCON_MAYTA.jpg";
import fotoFloresNino from "../assets/nosotros/plana_docente/DANIEL_HELI_FLORES_NINO.jpg";
import fotoJavier from "../assets/nosotros/plana_docente/JAVIER_ALARCON_MAYTA.jpg";
import fotoLucia from "../assets/nosotros/plana_docente/LUCIA_LILA_MENDOZA_HUERTAS.jpg";
import fotoMiguelM from "../assets/nosotros/plana_docente/MIGUEL_VALERIO_MILLONES_YAURI.jpg";
import fotoMarilu from "../assets/nosotros/plana_docente/MARILU_CARPIO_PEREZ.jpg";






// CV de Docentes Arquitectura de plataformas
import cvVidalon from "../assets/nosotros/plana_docente/CV_VIDALON_JORGE.pdf";
import cvPachas from "../assets/nosotros/plana_docente/CV_PACHAS_BARRIONUEVO.pdf";
import cvBenites from "../assets/nosotros/plana_docente/CV_BENITES_YGLESIAS.pdf";
import cvTasayco from "../assets/nosotros/plana_docente/CV_TASAYCO_YATACO.pdf";
import cvVega from "../assets/nosotros/plana_docente/CV_VEGA_CRUZ.pdf";
import cvGarriazo from "../assets/nosotros/plana_docente/CV_GARRIAZO_CASTAÑEDA.pdf";
import cvFlores from "../assets/nosotros/plana_docente/CV_FLORES_VARGAS.pdf";
import cvCortez from "../assets/nosotros/plana_docente/CV _José_Ricardo.pdf";
import cvChuan from "../assets/nosotros/plana_docente/CV_Anthony_ Francisco.pdf";
import cvChacaltana from "../assets/nosotros/plana_docente/CV_Chacaltama.pdf";

import cvElsa from "../assets/nosotros/plana_docente/CV_CASTILLA_ALMEYDA.pdf";
import cvTeresaCajo from "../assets/nosotros/plana_docente/CV_CAJO_ROJAS.pdf";
import cvMariaCristina from "../assets/nosotros/plana_docente/CV_MAGUINA_MALLMA.pdf";
import cvMarisela from "../assets/nosotros/plana_docente/CV_PALACIOS_CASTILLO.pdf";
import cvNorma from "../assets/nosotros/plana_docente/CV_QUISPE_MOLINA.pdf";
import cvValderrama from "../assets/nosotros/plana_docente/CV_VALDERRAMA_CASTRO.pdf";
import cvLuisa from "../assets/nosotros/plana_docente/CV_SANCHEZ_GARCIA.pdf";
import cvElizabeth from "../assets/nosotros/plana_docente/CV_ORE_CALLIRGOS.pdf";
import cvCoralia from "../assets/nosotros/plana_docente/CV_VILCA_GONZALES.pdf";

import cvFabiola from "../assets/nosotros/plana_docente/CV_RODRIGUEZ_VEGA.pdf";
import cvDiana from "../assets/nosotros/plana_docente/CV_SAENZ_CHARAJA.pdf";
import cvTeresaMontoya from "../assets/nosotros/plana_docente/CV_MONTOYA_VILLASANTE.pdf";
import cvVicente from "../assets/nosotros/plana_docente/CV_EGUSQUIZA_POZO.pdf";
import cvLeonor from "../assets/nosotros/plana_docente/CV_NIETO_POCOMUCHA.pdf";
import cvLizbeth from "../assets/nosotros/plana_docente/CV_JARA_RARAZ.pdf";
import cvSandra from "../assets/nosotros/plana_docente/CV_ORE_CALDERON.pdf";
import cvMercedes from "../assets/nosotros/plana_docente/CV_FUENTES_LAZO.pdf";

// 📌 CV – MECATRÓNICA AUTOMOTRIZ
import cvCurampa from "../assets/nosotros/plana_docente/CV_CURAMPA_DELACRUZ.pdf";
import cvMoises from "../assets/nosotros/plana_docente/CV_VARGAS_SOTO.pdf";
import cvMamani from "../assets/nosotros/plana_docente/CV_MAMANI_CHIPANA.pdf";
import cvGuillermo from "../assets/nosotros/plana_docente/CV_BARBOZA_TELLO.pdf";
import cvJimmy from "../assets/nosotros/plana_docente/CV_QUISPE_LLAMOCA.pdf";
import cvFelix from "../assets/nosotros/plana_docente/CV_RIVAS_CALLA.pdf";
import cvMontano from "../assets/nosotros/plana_docente/CV_MONTANO_VEGA.pdf";
import cvWashington from "../assets/nosotros/plana_docente/CV_RAMIREZ_PATINO.pdf";
import cvPanebra from "../assets/nosotros/plana_docente/CV_PANEBRA_MONTES.pdf";

import cvYolanda from "../assets/nosotros/plana_docente/CV_SUAREZ_DIAZ.pdf";
import cvCarmen from "../assets/nosotros/plana_docente/CV_ACCO_GAVILAN.pdf";
import cvCanelo from "../assets/nosotros/plana_docente/CV_CANELO_BLAS.pdf";
import cvMiguel from "../assets/nosotros/plana_docente/CV_HUARCAYA_FERNANDEZ.pdf";
import cvFiorela from "../assets/nosotros/plana_docente/CV_ORTIZ_ORTIZ.pdf";
import cvJohao from "../assets/nosotros/plana_docente/CV_RODRIGUEZ_QUISHAC.pdf";
import cvEmilia from "../assets/nosotros/plana_docente/CV_RAMIREZ_ARNAO.pdf";
import cvShannon from "../assets/nosotros/plana_docente/CV_CALDERON_QUISPE.pdf";

import cvNilton from "../assets/nosotros/plana_docente/CV_MICHUY_SUYO.pdf";
import cvRichard from "../assets/nosotros/plana_docente/CV_CELIS_CALERO.pdf";
import cvDaniel from "../assets/nosotros/plana_docente/CV_QUISPE_DELATORRE.pdf";
import cvRanilla from "../assets/nosotros/plana_docente/CV_RANILLA_MEDINA.pdf";
import cvWilmer from "../assets/nosotros/plana_docente/CV_ALARCON_MAYTA_W.pdf";
import cvFloresNino from "../assets/nosotros/plana_docente/CV_FLORES_NINO.pdf";
import cvJavier from "../assets/nosotros/plana_docente/CV_ALARCON_MAYTA_J.pdf";
import cvLucia from "../assets/nosotros/plana_docente/CV_MENDOZA_HUERTAS.pdf";
import cvMiguelM from "../assets/nosotros/plana_docente/CV_MILLONES_YAURI.pdf";
import cvMarilu from "../assets/nosotros/plana_docente/CV_CARPIO_PEREZ.pdf";


const PlanaDocente = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const abrirPDF = (pdf) => {
    setSelectedPdf(pdf);
  };

  const cerrarPDF = () => {
    setSelectedPdf(null);
  };


  const areas = [
      {
    nombre: "ARQUITECTURA DE PLATAFORMAS Y SERVICIOS TI",
    docentes: [
      { nombre: "HECTOR JORGE VIDALON JORGE", foto: fotoVidalon, cv: cvVidalon },
      { nombre: "PEDRO PACHAS BARRIONUEVO", foto: fotoPachas, cv: cvPachas },
      { nombre: "PATRICIA JANET BENITES YGLESIAS", foto: fotoBenites, cv: cvBenites },
      { nombre: "CARLOS TASAYCO YATACO", foto: fotoTasayco, cv: cvTasayco },
      { nombre: "HUMBERTO PABLO VEGA CRUZ", foto: fotoVega, cv: cvVega },
      { nombre: "JOHN HARRY GARRIAZO CASTAÑEDA", foto: fotoGarriazo, cv: cvGarriazo },
      { nombre: "CHRISTIAN FEDERICO FLORES VARGAS", foto: fotoFlores, cv: cvFlores },
      { nombre: "JOSÉ RICARDO CORTEZ CAMACHO", foto: fotoCortez, cv: cvCortez },
      { nombre: "ANTHONY FRANCISCO CHUAN GARCIA", foto: fotoChuan, cv: cvChuan },
      { nombre: "LUIS ALBERTO CHACALTANA ARNAO", foto: fotoChacaltana, cv: cvChacaltana },
    ],
  },

  {
    nombre: "CONTABILIDAD",
    docentes: [
      { nombre: "ELSA CASTILLA ALMEYDA", foto: fotoElsa, cv: cvElsa },
      { nombre: "TERESA CAJO ROJAS", foto: fotoTeresaCajo, cv: cvTeresaCajo },
      { nombre: "MARIA CRISTINA MAGUIÑA MALLMA", foto: fotoMariaCristina, cv: cvMariaCristina },
      { nombre: "MARISELA JANET PALACIOS CASTILLO", foto: fotoMarisela, cv: cvMarisela },
      { nombre: "NORMA YOLANDA QUISPE MOLINA", foto: fotoNorma, cv: cvNorma },
      { nombre: "FERNANDO VALDERRAMA CASTRO", foto: fotoValderrama, cv: cvValderrama },
      { nombre: "LUISA VERÓNICA SANCHEZ GARCIA", foto: fotoLuisa, cv: cvLuisa },
      { nombre: "ELIZABETH MANUELA ORE CALLIRGOS", foto: fotoElizabeth, cv: cvElizabeth },
      { nombre: "CORALIA VILCA GONZALES", foto: fotoCoralia, cv: cvCoralia },
    ],
  },

    {
    nombre: "ENFERMERÍA TÉCNICA",
    docentes: [
      { nombre: "FABIOLA RODRIGUEZ VEGA", foto: fotoFabiola, cv: cvFabiola },
      { nombre: "DIANA NOELIA SAENZ CHARAJA", foto: fotoDiana, cv: cvDiana },
      { nombre: "TERESA LILIANA MONTOYA VILLASANTE", foto: fotoTeresaMontoya, cv: cvTeresaMontoya },
      { nombre: "VICENTE EGUSQUIZA POZO", foto: fotoVicente, cv: cvVicente },
      { nombre: "LEONOR NIETO POCOMUCHA", foto: fotoLeonor, cv: cvLeonor },
      { nombre: "LIZBETH FABIOLA JARA RARAZ", foto: fotoLizbeth, cv: cvLizbeth },
      { nombre: "SANDRA ORÉ CALDERÓN", foto: fotoSandra, cv: cvSandra },
      { nombre: "MERCEDES FUENTES LAZO", foto: fotoMercedes, cv: cvMercedes },
    ],
  },

  {
    nombre: "MECATRÓNICA AUTOMOTRIZ",
    docentes: [
      { nombre: "CESAR AUGUSTO CURAMPA DE LA CRUZ", foto: fotoCurampa, cv: cvCurampa },
      { nombre: "VARGAS SOTO MOISÉS", foto: fotoMoises, cv: cvMoises },
      { nombre: "LUIS AGUSTÍN MAMANI CHIPANA", foto: fotoMamani, cv: cvMamani },
      { nombre: "GUILLERMO CARLOS BARBOZA TELLO", foto: fotoGuillermo, cv: cvGuillermo },
      { nombre: "JIMMY QUISPE LLAMOCA", foto: fotoJimmy, cv: cvJimmy },
      { nombre: "FELIX HANS RIVAS CALLA", foto: fotoFelix, cv: cvFelix },
      { nombre: "JUAN JOSÉ MONTAÑO VEGA", foto: fotoMontano, cv: cvMontano },
      { nombre: "WASHINGTON RAMIREZ PATIÑO", foto: fotoWashington, cv: cvWashington },
      { nombre: "JUAN CARLOS PANEBRA MONTES", foto: fotoPanebra, cv: cvPanebra },
    ],
  },
 {
    nombre: "TÉCNICA EN FARMACIA",
    docentes: [
      { nombre: "YOLANDA SUAREZ DIAZ", foto: fotoYolanda, cv: cvYolanda },
      { nombre: "CARMEN ROSA ACCO GAVILAN", foto: fotoCarmen, cv: cvCarmen },
      { nombre: "SEBERINO ALBERTO CANELO BLAS", foto: fotoCanelo, cv: cvCanelo },
      { nombre: "MIGUEL RAMIRO HUARCAYA FERNÁNDEZ", foto: fotoMiguel, cv: cvMiguel },
      { nombre: "FIORELA JEANETTE ORTIZ ORTIZ", foto: fotoFiorela, cv: cvFiorela },
      { nombre: "JOHAO JUNIOR RODRIGUEZ QUISHAC", foto: fotoJohao, cv: cvJohao },
      { nombre: "EMILIA RAMIREZ ARNAO", foto: fotoEmilia, cv: cvEmilia },
      { nombre: "SHANNON CALDERON QUISPE", foto: fotoShannon, cv: cvShannon },
    ],
  },
 {
    nombre: "DOCENTES DE EMPLEABILIDAD",
    docentes: [
      { nombre: "NILTON AQUILES MICHUY SUYO", foto: fotoNilton, cv: cvNilton },
      { nombre: "RICHARD MARIO CELIS CALERO", foto: fotoRichard, cv: cvRichard },
      { nombre: "DANIEL QUISPE DE LA TORRE", foto: fotoDaniel, cv: cvDaniel },
      { nombre: "JUAN LEOPOLDO RANILLA MEDINA", foto: fotoRanilla, cv: cvRanilla },
      { nombre: "WILMER ALARCÓN MAYTA", foto: fotoWilmer, cv: cvWilmer },
      { nombre: "DANIEL HELI FLORES NIÑO", foto: fotoFloresNino, cv: cvFloresNino },
      { nombre: "JAVIER ALARCÓN MAYTA", foto: fotoJavier, cv: cvJavier },
      { nombre: "LUCIA LILA MENDOZA HUERTAS", foto: fotoLucia, cv: cvLucia },
      { nombre: "MIGUEL VALERIO MILLONES YAURI", foto: fotoMiguelM, cv: cvMiguelM },
      { nombre: "MARILU CARPIO PEREZ", foto: fotoMarilu, cv: cvMarilu },
    ],
  },
   
    
  ];

  return (
    <section className="plana-docente-page">
  
      <div className="plana-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Plana Docente</h1>
          <p className="lead">
            Conoce la formación profesional y experiencia de nuestros docentes.
          </p>
        </div>
      </div>

   
      <div className="container py-5">
        <p className="text-center mb-5 descripcion">
          En esta sección podrás conocer la formación académica y profesional de
          cada uno de los docentes, así como su experiencia en las distintas
          áreas de especialidad.
        </p>

     
        {areas.map((area, index) => (
          <div key={index} className="mb-5" data-aos="fade-up">
            <h3 className="text-primary text-center section-subtitle mb-4">
              {area.nombre}
            </h3>

            <div className="row g-4 justify-content-center">
              {area.docentes.map((docente, i) => (
                <div
                  key={i}
                  className="col-md-3 col-sm-6 d-flex justify-content-center"
                >
                  <div className="docente-card text-center">
                    <div
                      className="docente-foto-container"
                      onClick={() => abrirPDF(docente.cv)}
                    >
                      <img
                        src={docente.foto}
                        alt={docente.nombre}
                        className="docente-foto"
                      />
                      <div className="docente-overlay">
                        <FaFilePdf size={30} color="#fff" />
                        <span>Ver CV</span>
                      </div>
                    </div>
                    <p className="docente-nombre mt-3">
                      <FaUserGraduate className="me-2 text-primary" />
                      {docente.nombre}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

   
      {selectedPdf && (
        <div className="pdf-modal" onClick={cerrarPDF}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={cerrarPDF}>
              ✕
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="Vista PDF"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default PlanaDocente;
